module.exports = __webpack_public_path__ + "img/tick.0cd7bd6d.svg";